const INITIAL_STATE = {
    data: null
}

const FicheirostReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'ficheiros': {

            return {
                ...state,
                data: action.payload.ficheiros
            }
        }
        default: {
            return state
        }
    }
}

export default FicheirostReducer